import { type FC } from 'react';
import { type SampleDefinitionDetailV1 } from '@/model/SamplePlan.model';
import { _isNil } from '@/littledash';

export const DetailCell: FC<{ detail?: SampleDefinitionDetailV1 }> = ({ detail }) => {
  if (_isNil(detail?.value)) {
    return (
      <div data-test-component="DetailCell" data-test-element="empty">
        -
      </div>
    );
  }
  return <div data-test-component="DetailCell" data-test-element="value">{`${detail.value}${detail.unit}`}</div>;
};
